@import (reference) '../../../../../constants/spacing.module.less';

@table-border: 0.5px solid var(--table--border-color);
@table-row-height: 40px;

.header-row {
  background-color: var(--default--background-color--14);
  border-bottom: @table-border;
  padding: @space-0 @space-16;
  align-items: center;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  height: @table-row-height;
}

.body-row {
  border-bottom: @table-border;
  padding: @space-0 @space-16;
  align-items: center;
  font-size: 12px;
  line-height: 16px;
  height: @table-row-height;
}

.body-rows {
  :last-child.body-row {
    border-bottom: none;
  }
}

.zero-items-placeholder {
  color: var(--default--text-color--17);
  height: @table-row-height;
  padding: @space-8 @space-16;
  place-content: center center;
}
